import { useRef } from "react";
import { Camera } from "lucide-react";

import styles from "./UserFormModal.module.css";

/** Profile photo picker. The image is held as a data URL, which is what the
 * staff-member endpoint stores. */
export const UserPhotoField = ({ value, onChange }) => {
  const fileInputRef = useRef(null);

  const handleFile = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (loaded) => onChange(loaded.target.result);
    reader.onerror = () =>
      console.error("Could not read the selected profile picture");
    reader.readAsDataURL(file);
  };

  return (
    <div className={styles.photoField}>
      <button
        type="button"
        className={styles.photoButton}
        onClick={() => fileInputRef.current?.click()}
        aria-label={value ? "Change profile picture" : "Add profile picture"}
      >
        {value ? (
          <img src={value} alt="" className={styles.photoPreview} />
        ) : (
          <Camera size={22} aria-hidden="true" />
        )}
      </button>
      <input
        type="file"
        ref={fileInputRef}
        className={styles.hiddenInput}
        accept="image/*"
        onChange={handleFile}
      />
      {!!value && (
        <button
          type="button"
          className={styles.photoRemove}
          onClick={() => onChange(null)}
        >
          Remove photo
        </button>
      )}
    </div>
  );
};
